import React, { HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface IBaseTitle {
  text: string;
  subTitle?: string;
  textColor?: string;
}

type TBaseTitleProps = IBaseTitle & HTMLAttributes<HTMLDivElement>;

const BaseTitle: React.FC<TBaseTitleProps> = (props) => {
  const { text, subTitle, textColor, className, ...otherProps } = props;

  return (
    <div
      className={twMerge("font-bold text-center", className)}
      {...otherProps}
    >
      <div className={twMerge("text-2xl font-bold", textColor)}>{text}</div>
      <div className={twMerge("text-base font-bold", textColor)}>
        {subTitle}
      </div>
    </div>
  );
};

export default BaseTitle;
